import { QRProps } from "@/contexts/QREditorContext/types";

/**
 * Determines if the MP3 preview should show the content wrapper
 */
export const shouldShowQrContentWrapper = (data: QRProps<"mp3">["data"] | null): boolean => {
  if (!data) return false;

  return Boolean(data.logoUrl || data.mp3Title || data.mp3Description || data.mp3FileUrl);
};

/**
 * Checks if download button should be shown
 */
export const shouldShowDownloadButton = (
  data: QRProps<"mp3">["data"] | null,
  isInitPreview: boolean
): boolean => {
  if (!data) return false;

  if (isInitPreview) return true;

  return Boolean(data.mp3FileUrl && data.allowDownload);
};

/**
 * Checks if share button should be shown
 */
export const shouldShowShareButton = (
  data: QRProps<"mp3">["data"] | null,
  isInitPreview: boolean
): boolean => {
  if (!data) return false;

  return isInitPreview || Boolean(data.mp3FileUrl);
};
